/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    rank_type: string;
    group_id: number;
}

export interface IRankInfo {
    rank: number;
    total_points: number;
}

export interface IOutput extends IUserBaseInfo {
    name: string; // name 和基础数据结构不一致
    rank_arr: IRankInfo[];
}

export const getCourseMyPointsRank = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.GET_COURSE_MY_POINTS_RANK, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};

export const getCourseMyPointsRankSync = fetchDataSync(getCourseMyPointsRank);
